import {createContext, useContext} from 'react';

const CampaignNetworkContext = createContext<string | undefined>(undefined);

export function useCampaignNetwork() {
  return useContext(CampaignNetworkContext);
}

export default CampaignNetworkContext;
